import React from 'react'
import Content from './Content'

const ContentLibrary = () => {
  return (
    <Content />
  )
}

export default ContentLibrary